import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eFoMonAnChiTietActionTypeIds, IFoMonAnChiTietActionTypes } from "../../action-types/dich-vu/IFoMonAnChiTietActionTypes";
import { IFoMonAnChiTietPageStateModel } from "../../page-state-model/dich-vu/IFoMonAnChiTietPageState";

const initialState: IFoMonAnChiTietPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	fo_monan_chitiets: [],
	fo_monan_chitiet_editing: undefined,
	fo_monan_chitiet_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false
}

export const foMonAnChiTietReducer = (state: IFoMonAnChiTietPageStateModel = initialState, action: IFoMonAnChiTietActionTypes): IFoMonAnChiTietPageStateModel => {
	switch (action.type) {
		case eFoMonAnChiTietActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eFoMonAnChiTietActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				fo_monan_chitiets: action.payload
			}
		case eFoMonAnChiTietActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				fo_monan_chitiets: []
			}
		case eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_START:
			return {
				...state
			}
		case eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				fo_monan_chitiet_editing: action.payload
			}
		case eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state
			}
		case eFoMonAnChiTietActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				fo_monan_chitiet_editing: action.payload
			}
		case eFoMonAnChiTietActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				fo_monan_chitiet_editing: undefined
			}
		case eFoMonAnChiTietActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				fo_monan_chitiet_selected_ids: action.payload
			}
		case eFoMonAnChiTietActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eFoMonAnChiTietActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eFoMonAnChiTietActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eFoMonAnChiTietActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				fo_monan_chitiet_editing: undefined
			}
		case eFoMonAnChiTietActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eFoMonAnChiTietActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eFoMonAnChiTietActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xóa thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				fo_monan_chitiet_editing: undefined,
				fo_monan_chitiet_selected_ids: []
			}
		case eFoMonAnChiTietActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		default:
			return state;
	}
}
